export default __webpack_public_path__ + "static/media/notFound.474b772a.svg";